<script setup lang="ts">
import logo from '@/assets/logo.png';

/**
 * Marchio Evolfin. Il file sta in `src/assets` (non in `public/`) perché lo
 * importano i componenti: così Vite gli mette l'hash nel nome e la cache
 * lunga vale anche per lui.
 *
 * Il logo è un anello verde su fondo trasparente: regge da solo sia il tema
 * chiaro sia lo scuro, quindi niente sfondo, raggio od ombra dietro.
 */
withDefaults(defineProps<{ dimensione?: number; decorativo?: boolean }>(), {
  dimensione: 48,
  decorativo: false,
});
</script>

<template>
  <img
    :src="logo"
    :width="dimensione"
    :height="dimensione"
    :alt="decorativo ? '' : 'Evolfin'"
    :aria-hidden="decorativo || undefined"
    :style="{ width: `${dimensione}px`, height: `${dimensione}px` }"
  />
</template>
